export default {
    l: {
        research: {
            startAngle: 0,
            finishAngle: -90,
            left: 684,
            top: 12,
        },
        design: {
            startAngle: -90,
            finishAngle: -180,
            left: 698,
            top: 39,
        },
        launch: {
            startAngle: -270,
            finishAngle: 0,
            // left: 626,
            left: 530,
            top: 38,
        },
    },
    xl: {
        research: {
            startAngle: 0,
            finishAngle: -90,
            left: 907,
            top: -105,
        },
        design: {
            startAngle: -90,
            finishAngle: -180,
            left: 880,
            top: -70,
        },
        launch: {
            startAngle: -270,
            finishAngle: 0,
            // left: 880,
            left: 750,
            top: -70,
        },
    },
};
